import { useState } from 'react'
import { Link } from 'react-router-dom'

const Footer = () => {
  const [isOpen, setIsOpen] = useState(false)

  const styles = {
    wrapper: {
      width: '100%',
      padding: '40px 16px 20px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      gap: '16px',
      background: '#fff',
      marginTop: 'auto',
    },
    content: {
      display: 'flex',
      gap: '24px',
      opacity: isOpen ? 1 : 0,
      transform: isOpen ? 'translateY(0)' : 'translateY(10px)',
      transition: 'opacity 0.3s ease, transform 0.3s ease',
      pointerEvents: isOpen ? 'auto' : 'none',
    },
    link: {
      fontSize: '11px',
      fontWeight: '500',
      color: '#000',
      textDecoration: 'none',
      textTransform: 'uppercase',
      letterSpacing: '0.5px',
      cursor: 'pointer',
    },
    toggleBtn: {
      width: '24px',
      height: '24px',
      background: 'none',
      border: 'none',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      pointerEvents: 'auto',
      color: '#000',
      padding: 0,
    }
  }

  return (
    <div style={styles.wrapper}>
      <button 
        onClick={() => setIsOpen(!isOpen)} 
        style={styles.toggleBtn}
        aria-label={isOpen ? "Close footer" : "Open footer"}
      >
        {isOpen ? (
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="1.5">
            <path d="M1 1l12 12M13 1L1 13" />
          </svg>
        ) : (
          <svg width="10" height="16" viewBox="0 0 10 16" fill="none" stroke="currentColor" strokeWidth="1.5">
            <path d="M1 1l7 7-7 7" />
          </svg>
        )}
      </button>

      <div style={styles.content}>
        <Link to="/about" style={styles.link}>О продавце</Link>
        <Link to="/terms" style={styles.link}>Условия</Link>
        <Link to="/privacy" style={styles.link}>Конфиденциальность</Link>
      </div>
    </div>
  )
}

export default Footer

